import { render, staticRenderFns } from "./AssetsDownload.vue?vue&type=template&id=71234d49&scoped=true&"
import script from "./AssetsDownload.vue?vue&type=script&lang=js&"
export * from "./AssetsDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71234d49",
  null
  
)

export default component.exports